export const TYPES = {
	pub: 'pub',
	friends: 'friends'
};

export const TIMER_LENGTHS = {
	noTimer: 0,
	default: 1,
	slow: 2,
	slower: 3
};

export const STATUSES = {
	created: 0,
	starting: 1,
	started: 2,
	finished: 3
};

export const STATUSES_NAMES = {
	0: 'created',
	1: 'starting',
	2: 'started',
	3: 'finished'
};

export const TEAMS = {
	one: 'one',
	two: 'two',
	neutral: 'neutral',
	assasin: 'assasin'
};

export const ACTIONS = {
	giveClue: 'giveClue',
	guess: 'guess'
};
